export function formatContractPaymentSchedule(
  rentPaymentDay?: number | string | null,
  existingSchedule?: string | null,
): string {
  const day = Number(rentPaymentDay);
  const hasDay = Number.isInteger(day) && day >= 1 && day <= 28;
  const schedule = (existingSchedule || '').trim();
  if (hasDay && schedule && schedule.includes(`ngày ${day}`)) {
    return schedule;
  }
  if (hasDay) {
    return `Chuyển khoản ngân hàng, thanh toán vào ngày ${day} hàng tháng`;
  }
  return schedule || 'Chuyển khoản ngân hàng';
}
